export const KEY_CODE: Readonly<Record<string, string>> = Object.freeze({
  ENTER: "Enter",
  SPACE: " ",
  ESCAPE: "Escape",
});
